import { VPCPeeringModal, VPCPeeringModalProps } from './VPCPeeringModal';
import { VPCPeeringFormMode } from '../../interface';

export type CreateVPCModalProps = Pick<VPCPeeringModalProps, 'open' | 'onClose' | 'onSuccess'>;

export function CreateVPCModal({ open, onClose, onSuccess }: CreateVPCModalProps) {
  return (
    <VPCPeeringModal
      open={open}
      mode={VPCPeeringFormMode.CREATE}
      onClose={onClose}
      onSuccess={onSuccess}
    />
  );
}
